// eslint-disable-next-line import/no-extraneous-dependencies
const SanityClient = require("@sanity/client");

exports.sanityClient = SanityClient({
    projectId: "4swbd7aj",
    dataset: process.env.GATSBY_SANITY_DATASET || "staging",
    token: process.env.GATSBY_SANITY_STUDIO_TOKEN,
    apiVersion: "2022-08-08",
});